import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import styles from './Layout.module.css';

export const Layout = () => {
  const location = useLocation();
  const hideHeader = location.pathname === '/coupon/seven-knights';

  return (
    <div className={styles.layout}>
      {!hideHeader && <Header />}
      <main className={styles.mainContent}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
